export const GET_LIST_PLANS = 'GET_LIST_PLANS';
export const GET_LIST_PLANS_DONE = 'GET_LIST_PLANS_DONE';
export const GET_LIST_PLANS_ERROR = 'GET_LIST_PLANS_ERROR';
export const GET_LIST_PLANS_RESET = 'GET_LIST_PLANS_RESET';
//# sourceMappingURL=actionTypes.js.map